import {
  URL_HOME,
  URL_PAGE_CUSTOMER_CLUB,
  URL_PAGE_CUSTOMER_CREDIT_BALANCE,
  URL_PAGE_CUSTOMER_CURRENT_PROGRAM,
  URL_PAGE_CUSTOMER_CURRENT_PROGRAM_DETAIL,
  URL_PAGE_CUSTOMER_DIET_CHAT,
  URL_PAGE_CUSTOMER_DIETITIAN,
  URL_PAGE_CUSTOMER_EARN_CREDIT,
  URL_PAGE_CUSTOMER_GUIDE,
  URL_PAGE_CUSTOMER_INFOS,
  URL_PAGE_CUSTOMER_ORDERS,
  URL_PAGE_CUSTOMER_ORDERS_COMING,
  URL_PAGE_CUSTOMER_ORDERS_PAST,
  URL_PAGE_EDIT_ADDRESS,
  URL_PAGE_MEN,
  URL_PAGE_SHIPMENT_DETAILS_CODE,
  URL_PAGE_SHIPMENT_EDIT,
  URL_PAGE_WOMEN,
} from "@middleware/constants";
import { useRouter } from "next/router";
import { useEffect, useState } from "react";

export const useStickyBars = () => {
  const [canShowStickyBar, setCanShowStickyBar] = useState(false);
  const router = useRouter();

  useEffect(() => {
    const shouldShow = [
      URL_HOME,
      URL_PAGE_MEN,
      URL_PAGE_WOMEN,
      URL_PAGE_CUSTOMER_ORDERS,
      URL_PAGE_CUSTOMER_ORDERS_COMING,
      URL_PAGE_CUSTOMER_ORDERS_PAST,
      URL_PAGE_CUSTOMER_DIETITIAN,
      URL_PAGE_CUSTOMER_DIET_CHAT,
      URL_PAGE_CUSTOMER_CLUB,
      URL_PAGE_CUSTOMER_CURRENT_PROGRAM,
      URL_PAGE_CUSTOMER_CURRENT_PROGRAM_DETAIL,
      URL_PAGE_CUSTOMER_INFOS,
      URL_PAGE_CUSTOMER_GUIDE,
      URL_PAGE_CUSTOMER_CREDIT_BALANCE,
      URL_PAGE_CUSTOMER_EARN_CREDIT,
      URL_PAGE_SHIPMENT_DETAILS_CODE,
      URL_PAGE_SHIPMENT_EDIT + "[token]",
      URL_PAGE_EDIT_ADDRESS + "[token]",
    ].includes(router.pathname);

    setCanShowStickyBar(shouldShow);
  }, [router.pathname]);

  return { canShowStickyBar };
};
